export const tokens = {
    interior: {
        spaceBefore: 20,
        spaceAfter: 4,
    },
    content: {
        gap: 10,
    },
    label: {
        size: {
            mobile: 14,
            desktop: 16,
        },
    },
    clearAction: {
        padding: 4,
        fontSize: 14,
    },
};
